export default "__VITE_ASSET__89a81331__"